export const mockNewsArchiveCategories = [
  {
    id: "1",
    name: "Morning Edition",
    slug: "morning-edition",
    createdAt: new Date(),
    updatedAt: new Date(),
  },
  {
    id: "2",
    name: "Evening Edition",
    slug: "evening-edition",
    createdAt: new Date(),
    updatedAt: new Date(),
  },
  {
    id: "3",
    name: "Weekend Special",
    slug: "weekend-special",
    createdAt: new Date(),
    updatedAt: new Date(),
  },
  {
    id: "4",
    name: "Sunday Edition",
    slug: "sunday-edition",
    createdAt: new Date(),
    updatedAt: new Date(),
  },
  {
    id: "5",
    name: "Special Edition",
    slug: "special-edition",
    createdAt: new Date(),
    updatedAt: new Date(),
  },
];
